import * as angular from "angular";

const events = {
  toggleMenuLoadingState : 'toggle-menu-loading-state'
};

const coordinationActionTypes = [
  {
    title: 'Send SMS',
    value: 'sendSMS'
  },
  {
    title: 'Create Deliveries',
    value: 'createDeliveries'
  }
];

const IEnumServiceStatus = {
  IdleGroup: 'idle',
  PendingGroup: 'pending',
  ValidatedGroup: 'validated',
  DeclinedGroup: 'declined',
  ServiceCreatedGroup: 'created'
};

const timeSlots = [
  {
    fromHour : 8,
    fromMinute : 0,
    toHour : 10,
    toMinute : 0
  },
  {
    fromHour : 9,
    fromMinute : 0,
    toHour : 11,
    toMinute : 0
  },
  {
    fromHour : 10,
    fromMinute : 0,
    toHour : 12,
    toMinute : 0
  },
  {
    fromHour : 11,
    fromMinute : 0,
    toHour : 13,
    toMinute : 0
  },
  {
    fromHour : 12,
    fromMinute : 0,
    toHour : 14,
    toMinute : 0
  },
  {
    fromHour : 13,
    fromMinute : 0,
    toHour : 15,
    toMinute : 0
  },
  {
    fromHour : 14,
    fromMinute : 0,
    toHour : 16,
    toMinute : 0
  },
  {
    fromHour : 15,
    fromMinute : 0,
    toHour : 17,
    toMinute : 0
  },
  {
    fromHour : 16,
    fromMinute : 0,
    toHour : 18,
    toMinute : 0
  },
  {
    fromHour : 17,
    fromMinute : 0,
    toHour : 19,
    toMinute : 0
  },
  {
    fromHour : 18,
    fromMinute : 0,
    toHour : 20,
    toMinute : 0
  }
];

angular
  .module('bringoz.admin.coordinations')
  .constant('CoordinationConstants', {
    events : events,
    coordinationActionTypes : coordinationActionTypes,
    IEnumServiceStatus : IEnumServiceStatus,
    timeSlots : timeSlots

  });

